export const baseURL = "https://api.luckygame.co.ug/";




export const baseURL_2 = "https://api.luckygame.co.ug/";


// export const baseURL = "http://localhost:2257"


// Warning std versions prefixed with 'v' will be deprecated on October 1st 2020. Please change your import to  (at https://deno.land/std@v0.63.0/fmt/colors.ts)
// http://localhost:8090]